var _defs, _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActualizar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#006E54;}.b{fill:#fff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 21,
    cy: 21,
    r: 21
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M7.471,19.331a.651.651,0,0,1-.651-.651,11.953,11.953,0,0,1,20.639-8.19V6.271a.651.651,0,0,1,.651-.651.664.664,0,0,1,.651.651v6.068a.651.651,0,0,1-1.2.365A10.638,10.638,0,0,0,8.122,18.68a.651.651,0,0,1-.651.651Z",
    transform: "translate(2.128 1.698)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.62,14.05a.625.625,0,0,1-.6-.417.651.651,0,0,1,.352-.846l6.146-2.448a.651.651,0,1,1,.482,1.2L18.894,14A.6.6,0,0,1,18.62,14.05Z",
    transform: "translate(5.497 3.099)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.981,29.561a.664.664,0,0,1-.651-.651V22.842a.651.651,0,0,1,1.2-.365A10.638,10.638,0,0,0,28.969,16.5a.651.651,0,0,1,1.3,0,11.953,11.953,0,0,1-20.639,8.19V28.91A.651.651,0,0,1,8.981,29.561Z",
    transform: "translate(2.584 4.789)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M8.98,22.592a.664.664,0,0,1-.6-.4.651.651,0,0,1,.365-.846l6.107-2.461a.654.654,0,0,1,.495,1.211L9.2,22.54a.534.534,0,0,1-.221.052Z",
    transform: "translate(2.586 5.69)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActualizar);
export default __webpack_public_path__ + "static/media/actualizar.46b4c5b16d4ccc43e9765f54d334cc24.svg";
export { ForwardRef as ReactComponent };